module.exports = "/_next/static/images/Hero@2x-57557b89b939a32fe5db297d7ae1e4c6.webp";